import { Button, ButtonProps } from '@chakra-ui/react';
import { FC, forwardRef } from 'react';

export type ToolbarButtonProps = ButtonProps & {
  isActive?: boolean;
};

export const ToolbarButton: FC<ToolbarButtonProps> = forwardRef(function ToolbarButton({ isActive, ...rest }, ref) {
  return (
    <Button
      ref={ref}
      type="button"
      colorScheme={isActive ? 'primary' : 'gray'}
      minWidth={'38px'}
      size="sm"
      fontSize="inherit"
      tabIndex={-1}
      border="default"
      borderColor={isActive ? 'primary' : 'neutral'}
      {...rest}
    />
  );
});
